import useI18n from 'src/hooks/useI18n'
import GridValue from './GridValue'

interface Props {
  filteredSort: string;
  setFilteredSort(sort: string): void;
  filterOnClick: boolean;
}

const GridOptions = (props: Props) => {
  const { filteredSort, setFilteredSort, filterOnClick } = props

  const translation = useI18n()

  return (
    <div
      className="content-wrapper">
      <GridValue
        filter={{ title: translation.filter.sort.newest, value: 'newest' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
      <GridValue
        filter={{ title: translation.filter.sort.oldest, value: 'oldest' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
      <GridValue
        filter={{ title: translation.filter.sort.lowest, value: 'lowest_price' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
      <GridValue
        filter={{ title: translation.filter.sort.highest, value: 'highest_price' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
      <GridValue
        filter={{ title: translation.filter.sort.az, value: 'az' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
      <GridValue
        filter={{ title: translation.filter.sort.za, value: 'za' }}
        filteredSort={filteredSort}
        setFilteredSort={setFilteredSort}
        filterOnClick={filterOnClick}
      />
    </div>
  )
}

export default GridOptions
